import { render, staticRenderFns } from "./LanguagesMultiselect.vue?vue&type=template&id=16f536de&scoped=true&"
import script from "./LanguagesMultiselect.vue?vue&type=script&lang=js&"
export * from "./LanguagesMultiselect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f536de",
  null
  
)

export default component.exports